/**
 * Set up your computer. Once per computer, before the first project.
 *
 * One prompt, one Copy button. The prompt is short and never changes: it points
 * the coding agent at /setup.md, where the real steps live, so fixing a step
 * never means asking anybody to copy a new prompt. English in every language,
 * for the same reason the project prompt is (lib/setup-prompt.ts).
 */

import { useNavigate } from 'react-router';

import { CopyField } from '../../components/patterns/CopyField';
import { Button } from '../../components/primitives/Button';

import { t } from '../../lib/i18n/t';
import { computerSetupPrompt } from '../../lib/setup-prompt';

import '../../styles/screens/onboarding.css';

export default function SetupComputer() {
  const navigate = useNavigate();
  return (
    <div className="onb">
      <div className="onb__col">
        <header className="onb__head">
          <h1 className="onb__title">{t('Set up your computer')}</h1>
          <p className="onb__sub">
            {t('Paste this into your coding agent once. It installs what it needs and signs in for you.')}
          </p>
        </header>

        <CopyField label={t('Computer setup prompt')} value={computerSetupPrompt()} />

        <p className="onb__sub">
          {t('It will open your browser once. Click Allow there. It will ask before anything needs your password.')}
        </p>

        <div className="onb__actions">
          <Button variant="solid" onClick={() => navigate('/new')}>
            {t("I've done this")}
          </Button>
          <Button variant="outline" onClick={() => navigate('/projects')}>
            {t('Not now')}
          </Button>
        </div>
      </div>
    </div>
  );
}
